// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-form-item[data-v-a43f292a]{margin-bottom:5px!important}", ""]);
// Exports
module.exports = exports;
